import React, { useState } from 'react';
import { Button, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { updateRoles } from '../../../../repository/OrganizationDAO';
import BaseModal from '../../../../components/modals/BaseModal';
import { useOrganizationContext } from '../../../../context/organization_context/OrganizationContext';
import { ToastType, useToast } from '../../../../context/toast/ToastContext';
import { useLoadingContext } from '../../../../context/loading/LoadingContext';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';

const AddRoleModal = ({ show, onHide, shouldRedirect = true }) => {
    const { organization } = useOrganizationContext();
    const { setLoadingData } = useLoadingContext();
    const { showToast } = useToast();
    const [newRole, setNewRole] = useState('');
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSubmit = async () => {
        setLoadingData(true);
        try {
            const result = await updateRoles(organization.id, newRole);
    
            if (result.success) {
                showToast(t(StringKeys.SUCCESS), ToastType.SUCCESS);
                resetForm();
                onHide();
                if (shouldRedirect) {
                    navigate(`/roles/${newRole}`);
                }
            } else {
                showToast(t(StringKeys.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN), ToastType.DANGER);
                console.error("Error creating role:", result.error);
            }
        } catch (error) {
            console.error("Unexpected error:", error);
            showToast(t(StringKeys.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN), ToastType.DANGER);
        } finally {
            setLoadingData(false);
        }
    };
    

    const resetForm = () => {
        setNewRole('');
    };

    const actions = (
        <Button onClick={handleSubmit}>{t(StringKeys.SUBMIT)}</Button>
    );

    return (
        <BaseModal
            open={show}
            onClose={() => {
                resetForm();
                onHide();
            }}
            maxWidth="sm"
            title={t(StringKeys.ADD_ROLE)}
            actions={actions}
        >
            <TextField
                autoFocus
                margin="dense"
                id="role"
                label={t(StringKeys.ROLE_NAME)}
                type="text"
                fullWidth
                variant="outlined"
                value={newRole}
                onChange={(e) => setNewRole(e.target.value)}
            />
        </BaseModal>
    );
};

export default AddRoleModal;